/* @jsxImportSource @emotion/react */
import LocalizationProvider from '@hds-routing/component-library/LocalizationProvider';
import ThemeProvider from '@hds-routing/component-library/ThemeProvider';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import Loadable from 'react-loadable';
import { HashRouter } from 'react-router-dom';
import createStore from './store';

import App from './app/App';
import { PostHogProvider } from './app/providers/PostHogProvider';

// Create a store and get back itself and its history object
const { store } = createStore();

// Running locally, we should run on a <ConnectedRouter /> rather than on a <StaticRouter /> like on the server
// Let's also let React Frontload explicitly know we're not rendering on the server here
const Application = (
    <PostHogProvider>
        <ReduxProvider store={store}>
            <HashRouter>
                <LocalizationProvider>
                    <ThemeProvider>
                        <App />
                    </ThemeProvider>
                </LocalizationProvider>
            </HashRouter>
        </ReduxProvider>
    </PostHogProvider>
);

const appRoot = document.getElementById('app-root');

if (appRoot) {
    if (appRoot.hasChildNodes()) {
        Loadable.preloadReady().then(() => {
            hydrateRoot(appRoot, Application);
        });
    } else {
        const root = createRoot(appRoot);
        root.render(Application);
    }
}
